export enum REPL_TYPE {
    'DC_TO_STORE' = 1,
    'VENDOR_TO_STORE' = 2,
    'STORE_TO_STORE' = 3, 
    'CROSS_DOCK' = 4, 
    'FLOW_THROUGH' = 5
}

export const REPL_TYPE_LABELs = {
    [REPL_TYPE.DC_TO_STORE] : 'DC TO STORE',
    [REPL_TYPE.VENDOR_TO_STORE] : 'VENDOR TO STORE',
    [REPL_TYPE.STORE_TO_STORE] : 'STORE TO STORE', 
    [REPL_TYPE.CROSS_DOCK] : 'CROSS DOCK', 
    [REPL_TYPE.FLOW_THROUGH] : 'FLOW THROUGH'
}